module.exports = __webpack_public_path__ + "img/fail.9baa4112.png";